import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  CustomAutocompleteArrStringNoForm,
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useRef, useState } from 'react';
import { gridSizeMdLg12, handleAxiosError, useDownloadFile } from '@/shared';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const OPTIONS_OPERADORAS_NAPS = [
  "Red Neutra",
  "Hallo Machala",
  "Hallo Azogues",
  "Nedetel",
  "Astronet",
  "Fibramax",
]

let toastId:any;

const mostrarToast = () => {
  toastId = toast.loading("Descargando reporte...", {
    closeOnClick: false,
    draggable: false
  });
};

const cerrarToast = () => {
  toast.dismiss(toastId);
};

const ModalGenerarReportesNaps: React.FC<ConfirmRejectOTDialogProps> = ({
  open,
  setOpen,
}) => {
  const [expanded, setExpanded] = useState<number | null>(0);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  
  const formReporteNaps = useForm({
    defaultValues:{
      version:1,
      operadora:""
    }
  })

  const handleChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    console.log(event)
    setExpanded(isExpanded ? panel : null);
  };

  async function DownloadNAPReport() {
    try {
      mostrarToast()
      const {handleDownloadFile} = useDownloadFile()
      await handleDownloadFile({
        url:"api/v1/reporte-naps/",
        method:"post",
        data:{descargar:true},
        nameFile:`Reporte General NAPs EVA - ${dayjs().format("DD-MM-YYYY")}`,
        extensionFile:"xlsx"
      })
      

    } catch (error) {
      handleAxiosError(error);
    }
    cerrarToast()
    setOpen(false);
  }

  const generarReporteOperadora = async() => {
    try {
      const {handleDownloadFile} = useDownloadFile()
      mostrarToast()
      await handleDownloadFile({
        url:"api/v1/reporte-naps-operadora/",
        method:"post",
        data:{
          operadora:formReporteNaps.getValues("operadora")?.toLowerCase(),
          version:formReporteNaps.getValues("version"),
        },
        nameFile:`Reporte NAPs por Operadora ${formReporteNaps.getValues("operadora")} - ${dayjs().format("DD-MM-YYYY")}`,
        extensionFile:"xlsx"
      })
      
    } catch (error) {
      handleAxiosError(error);
    }
    cerrarToast()
    setOpen(false);
  }


  const generarReporteDesfogues = async() => {
    const {handleDownloadFile} = useDownloadFile()
    mostrarToast()
    await handleDownloadFile({
      url:"api/v1/reporte-naps-desfogue/",
      method:"post",
      data:{
        operadora:formReporteNaps.getValues("operadora")?.toLowerCase(),
        version:formReporteNaps.getValues("version"),
      },
      nameFile:`Reporte NAPs con Desfogue - ${dayjs().format("DD-MM-YYYY")}`,
      extensionFile:"xlsx",
      customErrorMessage:"No hay desfogues registrados."
    })
      
    cerrarToast()
    setOpen(false);
  }

  return (
    <ScrollableDialogProps
      open={open}
      title="Generar Reporte de NAPS"
      cancelTextBtn="Cerrar"
      showConfirmBtn={false}
      // actions
      onClose={() => {
        setOpen(false);
      }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container item {...gridSizeMdLg12} spacing={3} justifyContent={"center"}>
            <Grid container item {...gridSizeMdLg12}>
              {/* Reporte de todas las NAPS */}
              <Accordion
                key={`seccion-pasos-area-${0}`}
                expanded={expanded === 0}
                onChange={handleChange(0)}
                sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray"}}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{backgroundColor:"whitesmoke"}}
                >
                  <TabTextLabel color="black" text={`Reporte de todas las NAPS`} mt={0} pb={0} pl={0} pt={0} />
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:"white", }}>
                  <Grid container item {...gridSizeMdLg12} padding={3} sx={{border:2, borderColor:"whitesmoke"}} ref={(el) => (sectionRefs.current[0] = el)} my={2}>
                      <Typography>Genera un reporte de todas las NAPs cargadas en el sistema y lo descarga en formato Excel</Typography>
                  </Grid>
                  <Grid container item {...gridSizeMdLg12} my={2}>
                    <Button variant="contained" color="primary" fullWidth onClick={DownloadNAPReport}>Generar Reporte NAPs</Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* Reporte de todas las NAPS filtradas por OPERADORA */}
              <Accordion
                key={`seccion-pasos-area-${1}`}
                expanded={expanded === 1}
                onChange={handleChange(1)}
                sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray"}}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{backgroundColor:"whitesmoke"}}
                >
                  <TabTextLabel color="black" text={`Reporte de NAPS por Operadora`} mt={0} pb={0} pl={0} pt={0} />
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:"white", }}>
                  <Grid container item {...gridSizeMdLg12} padding={3} sx={{border:2, borderColor:"whitesmoke"}} ref={(el) => (sectionRefs.current[0] = el)} my={2}>
                      <Typography>Genera un reporte de todas las NAPs cargadas en el sistema por operadora y lo descarga en formato Excel</Typography>
                  </Grid>
                  <Grid container item {...gridSizeMdLg12} gap={2}>
                    <CustomAutocompleteArrStringNoForm
                      label="Seleccione una Operadora"
                      options={OPTIONS_OPERADORAS_NAPS.concat("")}
                      defaultValue={""}
                      onChangeValue={(value:string) => formReporteNaps.setValue("operadora", value)}
                      size={gridSizeMdLg12}
                    />
                    <Button variant="contained" color="primary" fullWidth
                    onClick={()=>{
                      if(formReporteNaps.getValues("operadora") === ""){
                        toast.error("Debe seleccionar una operadora");
                        return;
                      }
                      generarReporteOperadora()
                    }}>
                      Generar Reporte por Operadora
                    </Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* Reporte de NAPS con desfogue */}
              <Accordion
                key={`seccion-pasos-area-${2}`}
                expanded={expanded === 2}
                onChange={handleChange(2)}
                sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray"}}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{backgroundColor:"whitesmoke"}}
                >
                  <TabTextLabel color="black" text={`Reporte de Naps con Desfogue`} mt={0} pb={0} pl={0} pt={0} />
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:"white", }}>
                  <Grid container item {...gridSizeMdLg12} padding={3} sx={{border:2, borderColor:"whitesmoke"}} ref={(el) => (sectionRefs.current[2] = el)} my={2}>
                      <Typography>Genera un reporte de todas las NAPs que tengan desfogues y lo descarga en formato Excel</Typography>
                  </Grid>
                  <Grid container item {...gridSizeMdLg12} my={2}>
                    <Button variant="contained" color="primary" fullWidth onClick={generarReporteDesfogues}>Generar Reporte NAPs con Desfogue</Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

          </Grid>
        </>
      }
    />
  );
};

export default ModalGenerarReportesNaps;
